import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { del, get, post, put } from '../../../utils/fetchAPI';
import { showSuccessToast } from '../../../utils/toaster-alert';
import CustomModal from '../../common/modal/modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faSquarePlus, faTrash } from '@fortawesome/free-solid-svg-icons';

export const ReferraListCreate = () => {
    const [referralList, setReferralList] = useState([])
    const { user } = useSelector((state) => state.auth);
    const [updatedData, setUpdatedData] = useState({})
    const [createData, setCreateData] = useState({})
    const [show, setShow] = useState(false)

    useEffect(() => {
        getRefferalList(user?.user?._id)
    }, [])

    const getRefferalList = async (doctorId = user?.user?._id) => {
        await get(`/doctor/referral/${doctorId}`)
            .then((res) => {
                if (res?.status == 200) {
                    setReferralList(res?.data)
                    setUpdatedData({})
                    setCreateData({})
                }
            })
            .catch(() => { });
    }

    const addReferral = async (doctorId, data) => {
        await post(`/doctor/referral/create`, {
            "doctorId": doctorId,
            "details": data?.details
        })
            .then((res) => {
                if (res?.status == 200) {
                    getRefferalList()
                    setCreateData({})
                    showSuccessToast("Created successfully")
                }
            })
            .catch(() => { });
    }

    const updateReferral = async (doctorId, updatedReferral) => {
        await put(`/doctor/referral/update`, {
            "doctorId": doctorId,
            "referralId": updatedReferral?.id,
            "details": updatedReferral?.details
        })
            .then((res) => {
                if (res?.status == 200) {
                    getRefferalList()
                    showSuccessToast("Updated successfully")
                }
            })
            .catch(() => { });
    }

    const deleteReferral = async (updatedReferral) => {
        await del(`/doctor/referral/delete/${updatedReferral?.id}`)
            .then((res) => {
                if (res?.status == 200) {
                    setShow(false)
                    getRefferalList()
                    showSuccessToast("deleted successfully")
                }
            })
            .catch(() => { });
    }

    return (
        <div className="settings-list-card">
            <p className="settings-list-card__header">Referral templates</p>
            <div className="settings-list-card__composer">
                <textarea
                    className="settings-list-card__field"
                    onChange={(e) => {
                        setCreateData({
                            details: e.target.value
                        })
                    }}
                    value={createData?.details || ""}
                    rows={2}
                    placeholder="Add a saved referral line…"
                />
                <button
                    type="button"
                    className="settings-list-card__add-btn"
                    onClick={() => {
                        addReferral(user?.user?._id, createData)
                    }}
                    disabled={!createData?.details}
                    title="Add referral"
                >
                    <FontAwesomeIcon icon={faSquarePlus} size="xs" />
                </button>
            </div>
            {referralList?.length > 0 ? (
                <div className="settings-list-card__list">
                    {referralList?.map((data, index) => {
                        return (
                            <div key={index} className="settings-list-card__row">
                                <textarea
                                    className="settings-list-card__field"
                                    onChange={(e) => {
                                        setUpdatedData({
                                            id: data?._id,
                                            details: e.target.value
                                        })
                                    }}
                                    value={data?._id == updatedData?.id ? updatedData?.details : data?.details}
                                    rows={2}
                                />
                                <div className="settings-list-card__actions">
                                    <button
                                        type="button"
                                        className="settings-list-card__icon-btn settings-list-card__icon-btn--save"
                                        onClick={() => {
                                            updateReferral(user?.user?._id, updatedData)
                                        }}
                                        disabled={updatedData?.id != data?._id}
                                        title="Save"
                                    >
                                        <FontAwesomeIcon icon={faFloppyDisk} size="xs" />
                                    </button>

                                    <button
                                        type="button"
                                        className="settings-list-card__icon-btn settings-list-card__icon-btn--delete"
                                        onClick={() => {
                                            setUpdatedData({
                                                id: data?._id,
                                                details: data?.details
                                            })
                                            setShow(true)
                                        }}
                                        title="Delete"
                                    >
                                        <FontAwesomeIcon icon={faTrash} size="xs" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <p className="settings-list-card__empty">No referral templates yet. Add one above.</p>
            )}

            <CustomModal
                size="sm"
                show={show}
                isHeaderHide={true}
                setShow={setShow}
            >
                <div className='mt-0  create-template px-2 py-2'>
                    <p>Delete this referral template?</p>
                    <div className='text-center mt-2'>
                        <button onClick={() => {
                            deleteReferral(updatedData)
                        }} className='btn py-0 mr-1 bg-danger'>Delete
                        </button>
                        <button onClick={() => setShow(false)} className='btn py-0'>Cancel</button>
                    </div>
                </div>
            </CustomModal>
        </div>
    )
}
